'use client';
import {useState} from 'react';
import {handleLogin, loginState} from '@/utils/event/util';
import globalDomains from '@/utils/global-domains';
import {motion} from 'framer-motion';
import usePlayer from '@/components/ai/savvy/archive/hook/usePlayer';
import styles from './style.module.scss';

const SavygEventAward = () => {
  const {player, isOpenPlayer, openPlayer, closePlayer, handleLoadPlayer} =
    usePlayer();
  const [isNoticeOpen, setIsNoticeOpen] = useState(false);

  const toggleNotice = () => {
    setIsNoticeOpen((prev) => !prev);
  };

  const handleClickSavygCreate = () => {
    window.open(
      `${globalDomains.WWW_AFREECATV}/ai/savyg`,
      '_blank',
      'width=768,height=857',
    );
  };

  const handleSavygPage = () => {
    window.open(`${globalDomains.WWW_AFREECATV}/ai/savyg/archive`);
  };

  const handleOpenPlayer = (e, titleNo) => {
    e.preventDefault();
    openPlayer();
    handleLoadPlayer(titleNo);
  };

  return (
    <>
      <div id={styles.wrap}>
        <header className={styles.header}>
          <div className={styles.inner}>
            <h1>
              <a href={`${globalDomains.WWW_AFREECATV}`} target='_blank'>
                SOOP
              </a>
            </h1>
            <div className={styles.login_wrap}>
              {loginState ? (
                <>
                  <button
                    type='button'
                    className={styles.logout}
                    onClick={handleLogin}>
                    로그아웃
                  </button>
                </>
              ) : (
                <button
                  type='button'
                  className={styles.login}
                  onClick={handleLogin}>
                  로그인
                </button>
              )}
            </div>
          </div>
        </header>

        <div className={styles.visualArea}>
          <div className={styles.inner}>
            <div className={styles.title_box}>
              <span>최고의 딸ㅡ깍 아티스트는 누구?</span>
              <h3>숲 AI 영상 콘테스트</h3>
              <h4>콘테스트 수상작</h4>
              <p>총 3260개의 작품중 최고의 딸ㅡ깍 아트를 지금 공개합니다!</p>
            </div>
          </div>
        </div>
        <section className={styles.section1}>
          <div className={styles.inner}>
            <div className={styles.title_box}>
              <motion.h3
                className={styles.title}
                initial={{y: 60, opacity: 0}}
                whileInView={{y: 0, opacity: 1}}
                transition={{duration: 0.3}}
                viewport={{once: true}}>
                대상
              </motion.h3>
            </div>
            <motion.div
              className={styles.cont_box}
              initial={{y: 60, opacity: 0}}
              whileInView={{y: 0, opacity: 1}}
              transition={{duration: 0.3, delay: 0.3}}
              viewport={{once: true}}>
              <div className={`${styles.item_list} ${styles.prize1}`}>
                <div className={styles.thumb_box}>
                  <a onClick={(e) => handleOpenPlayer(e, 178658185)}>
                    <span className={styles.thumb}>
                      <img
                        src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_01.png`}
                        alt=''
                      />
                    </span>
                  </a>
                </div>
                <div className={styles.info_area}>
                  <span className={styles.nick}>by. dersa1021</span>
                  <p className={styles.tit}>[SAVYG] 여왕네</p>
                  <span className={styles.strm_nick}>아이네♪</span>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
        <section className={styles.section2}>
          <div className={styles.inner}>
            <div className={styles.title_box}>
              <motion.h3
                className={styles.title}
                initial={{y: 60, opacity: 0}}
                whileInView={{y: 0, opacity: 1}}
                transition={{duration: 0.3}}
                viewport={{once: true}}>
                최우수상
              </motion.h3>
            </div>
            <motion.div
              className={styles.cont_box}
              initial={{y: 60, opacity: 0}}
              whileInView={{y: 0, opacity: 1}}
              transition={{duration: 0.3, delay: 0.3}}
              viewport={{once: true}}>
              <div className={`${styles.list_wrap} ${styles.prize2}`}>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 178331627)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_02.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. gustnzja</span>
                    <p className={styles.tit}>[SAVYG] 테토남 홍타쿠</p>
                    <span className={styles.strm_nick}>홍타쿠!</span>
                  </div>
                </div>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 176685805)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_03.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. riruriru</span>
                    <p className={styles.tit}>[SAVYG] AI김쿼카 - 탕후루</p>
                    <span className={styles.strm_nick}>김쿼카_</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <section className={styles.section3}>
          <div className={styles.inner}>
            <div className={styles.title_box}>
              <motion.h3
                className={styles.title}
                initial={{y: 60, opacity: 0}}
                whileInView={{y: 0, opacity: 1}}
                transition={{duration: 0.3}}
                viewport={{once: true}}>
                최우수상
              </motion.h3>
            </div>
            <motion.div
              className={styles.cont_box}
              initial={{y: 60, opacity: 0}}
              whileInView={{y: 0, opacity: 1}}
              transition={{duration: 0.3, delay: 0.3}}
              viewport={{once: true}}>
              <div className={`${styles.list_wrap} ${styles.prize3}`}>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 178807403)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_04.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. yannickbovy</span>
                    <p className={styles.tit}>[SAVYG] 텍스트</p>
                    <span className={styles.strm_nick}>솜주먹</span>
                  </div>
                </div>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 176421077)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_05.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. nnamwooya1</span>
                    <p className={styles.tit}>[SAVYG] 텍스트</p>
                    <span className={styles.strm_nick}>릴파♬</span>
                  </div>
                </div>
              </div>
              <div className={`${styles.list_wrap} ${styles.prize3}`}>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 177271735)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_06.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. qa159123</span>
                    <p className={styles.tit}>[SAVYG] 겨우디 손인사 1</p>
                    <span className={styles.strm_nick}>겨우디_</span>
                  </div>
                </div>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 177451723)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_07.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. pkidoo</span>
                    <p className={styles.tit}>
                      [캐치][SAVYG] 내가 츠캄에 소주양이다
                    </p>
                    <span className={styles.strm_nick}>소주양</span>
                  </div>
                </div>
                <div className={styles.item_list}>
                  <div className={styles.thumb_box}>
                    <a onClick={(e) => handleOpenPlayer(e, 178117417)}>
                      <span className={styles.thumb}>
                        <img
                          src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/savyg_contest_award/img/thumb_08.png`}
                          alt=''
                        />
                      </span>
                    </a>
                  </div>
                  <div className={styles.info_area}>
                    <span className={styles.nick}>by. cotton1217</span>
                    <p className={styles.tit}>[SAVYG] 케이 챌린지</p>
                    <span className={styles.strm_nick}>주르르</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        <div className={styles.desc_area}>
          <div className={styles.desc}>
            많은 참여 감사해요 앞으로 더 재밌는 AI로 돌아올게요!
          </div>
          <div className={styles.btn_area}>
            <button
              type='button'
              className={styles.btn_visual}
              onClick={handleClickSavygCreate}>
              SAVYG 영상 만들기
            </button>
            <button
              type='button'
              className={styles.btn_savyg}
              onClick={handleSavygPage}>
              SAVYG 페이지 구경가기
            </button>
          </div>
        </div>
        <div
          className={`${styles.notice_area} ${isNoticeOpen ? styles.active : ''}`}>
          <div className={styles.inner}>
            <button type='button' onClick={toggleNotice}>
              <strong className={styles.title}>
                이벤트 <em>유의사항</em>
              </strong>
            </button>

            <ul className={styles.list}>
              <li>
                이벤트 기간, 응모 방법, 경품 내용, 당첨자 발표 일정은 사전
                공지된 내용에 따릅니다.
              </li>
              <li>
                당첨자가 제공한 개인정보가 허위이거나, 자동 프로그램·타인 정보
                도용 등 부정한 방법으로 응모한 사실이 확인될 경우 당첨은
                취소되며 경품은 회수될 수 있습니다.
              </li>
              <li>
                1인 다회 응모 가능하나 동일 계정 다수 당첨 시 1건만 인정됩니다.
              </li>
              <li>
                경품은 문화상품권으로 제공되며, 발행사 정책에 따른 사용처 및
                유효기간이 적용됩니다. 환불·환전은 불가합니다.
              </li>
              <li>
                경품은 사정에 따라 동등한 가치의 다른 상품으로 대체될 수
                있습니다.
              </li>
              <li>
                운영 정책 위반 또는 부정한 방법으로 이벤트 참여시 당첨에서
                제외될 수 있습니다.
              </li>
              <li>
                카카오 선물하기 알림톡을 통해 11월 25일 오후 중 문화 상품권
                모바일 교환권으로 일괄 발송됩니다.
              </li>

              <li>
                잘못된 정보로 상품을 받지 못한 경우 재발송해 드리지 않습니다.
              </li>
              <li>
                이벤트 당첨자는 개별 안내 예정이며, 당첨자와 연락이 어려운 경우
                상품 지급이 불가하오니 사전에 쪽지 수신 거부 해제 바랍니다.
              </li>
              <li>
                프로모션 기간 이전 제작한 영상은 응모 내역에 포함되지 않습니다.
              </li>
              <li>
                소득세법 제21조 및 제84조 제2항 제3호 등에 따라 5만원을 초과하는
                경품이나 상금의 경우 상품 금액의 22% 제세공과금을 지불해야
                합니다.
              </li>
              <li>
                이벤트 참여 과정에서 수집된 개인정보는 당첨자 확인 및 경품 발송,
                세무 처리 목적으로만 이용되며, 보유 기간 종료 후 파기됩니다.
              </li>
              <li>
                안내 드린 기한 내 제세공과금을 납부하지 않으면 당첨이 취소될 수
                있습니다.
              </li>
              <li>
                당첨자의 계정 명의와 신분증, 제세공과금 납부자의 명의가 모두
                일치해야 경품이 정상적으로 배송됩니다. 명의가 일치하지 않을
                경우, 당첨이 취소될 수 있으니 반드시 확인 부탁드립니다.
              </li>
              <li>
                경품 양도·판매·환전은 불가하며, 이를 위반할 경우 발생하는 모든
                책임은 당첨자 본인에게 있습니다.
              </li>
              <li>
                당첨자 발표 및 상품 지급일은 당사 사정에 의해 변경될 수
                있습니다.
              </li>
              <li>본 이벤트는 당사 사정에 의해 조기 종료될 수 있습니다.</li>
            </ul>
          </div>
        </div>

        <footer className={styles.footer}>ⓒ SOOP Corp.</footer>
      </div>
      {isOpenPlayer && (
        <div className='_Modal_UI_Wrap dimed'>
          <div
            className='flex_box'
            style={{flexDirection: 'column', gap: '15px'}}>
            <div className={styles.award_video_layer}>
              <strong>{player.title}</strong>
              <div className={styles.video_box}>
                <div id='savyg_player'></div>
              </div>
              <button
                type='button'
                className={styles.close}
                onClick={closePlayer}>
                레이어닫기
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SavygEventAward;
